import type { ISidebarModule } from "@fondationcss/ui";

export const sidebarItems: ISidebarModule[] = [
  {
    module: 'Kwiz.Quizzes',
    items: [
      { header: 'Quiz' },
      { title: 'Mes Quiz', icon: 'question-circle', to: '/quizzes', permission: 'Kwiz.Quizzes.View' },
      { title: 'Historique', icon: 'play', to: '/sessions', permission: 'Kwiz.Quizzes.View' },
      { title: 'Rapports', icon: 'chart-bar', to: '/reports', permission: 'Kwiz.Quizzes.View' },
    ]
  },
];
